import { useState } from "react";
import { useSearchParams } from "react-router-dom";

import { useT } from "@repo/transifex";
import { useUserProductsPos } from "~/api/products/hooks/use-user-products";
import { Dialog, DialogLoading, DialogPayment, NumPad } from "~/components";
import { useOrder } from "~/hooks/queries/orders";
import { calculateAmountForSaldo } from "~/utils/basket";
import { useUserBalance } from "~/hooks/use-user-balance";
import { useCurrentTillLocalisation } from "~/api/tills/hooks/use-till-current/localisation";
import { useBasketContext } from "~/providers/store/basket/context";

import { CalculatorButtons } from "./CalculatorButtons";

export const PosCashPage = () => {
  const t = useT();

  const { data: userProducts } = useUserProductsPos();
  const productsInBasket = useBasketContext((state) => state.productsInBasket);

  const { currency } = useCurrentTillLocalisation();

  const availableBalance = useUserBalance({
    unitAvailableInclVat:
      userProducts?.user?.collectLimit?.unitAvailableInclVat,
    balance: userProducts?.user?.balance
  });

  const [searchParams] = useSearchParams();
  const orderId = searchParams.get("orderId");

  const { data: order, status } = useOrder(orderId);

  const [received, setReceived] = useState(0);

  const totalPriceFromBasket = productsInBasket.reduce(
    (acc, product) => acc + product.totalPrice,
    0
  );

  const totalPrice =
    calculateAmountForSaldo(
      order ? order.totalPriceUnit : totalPriceFromBasket,
      availableBalance
    ).payWithOther / 100;

  const change = (received || totalPrice) - totalPrice;
  const formattedChange = Math.round(change * 100) / 100;

  if (order?.status === "paid") {
    const cashChange = received - order.totalPriceUnit / 100;
    return (
      <DialogPayment change={cashChange} orderId={order.id} status="success" />
    );
  }

  if (order?.status === "failed") return <DialogPayment status="error" />;

  // In the reimbursement flow, skip the calculator display
  if (totalPrice <= 0) return <DialogLoading />;

  return (
    <Dialog size="lg">
      <div className="flex w-full flex-col">
        <NumPad
          label={received > 0 ? t("Received") : t("To pay")}
          placeholder={totalPrice}
          setValue={setReceived}
          value={received}
          currency={currency}
          layout="horizontal"
        />
        <CalculatorButtons
          change={formattedChange}
          loadingOrder={status === "pending"}
          orderId={orderId}
          received={received}
        />
      </div>
    </Dialog>
  );
};
